import { createI18n } from "vue-i18n";
import { DEFAULT_LOCALE, normalizeLocale } from "@/utils/localeUtils.js";
import { buildLocaleMessages } from "./messages.js";

const savedLocale = normalizeLocale(localStorage.getItem("locale"));

const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: DEFAULT_LOCALE,
  messages: buildLocaleMessages()
});

export default i18n;
